import { render, staticRenderFns } from "./AdvertisementCreate.vue?vue&type=template&id=2bb709f1&scoped=true"
import script from "./AdvertisementCreate.vue?vue&type=script&lang=js"
export * from "./AdvertisementCreate.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementCreate.vue?vue&type=style&index=0&id=2bb709f1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb709f1",
  null
  
)

export default component.exports